module.exports = __webpack_public_path__ + "static/media/prestador.a676f1b0.jpg";